<template>
  <IzGrid class="card-question-detail">
    <IziCol>
      <IziGrid>
        <IziCol xl="2" lg="12" md="2" sm="12">
          Question {{ index + 1 }}:
        </IziCol>
        <IziCol xl="10" lg="10" md="10" sm="12">
          <IziGrid>
            <IziCol>
              <IziGrid>
                <IziCol xl="11" lg="11" md="11" col="11">
                  <IziInput
                    class="card-question-name"
                    label="Enter your question"
                    v-model:value="question.name"
                  />
                </IziCol>
                <IziCol xl="1" lg="1" md="1" col="1" class="col-add-image">
                  <UploadImage
                    v-model:imageUrl="question.image"
                    imageType="question"
                    onlyIcon="true"
                  />
                </IziCol>
              </IziGrid>
            </IziCol>
            <IziCol v-if="!checkChallengeType().openEnded">
              <Answers :question="question" />
            </IziCol>
          </IziGrid>
        </IziCol>
      </IziGrid>
    </IziCol>
  </IzGrid>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { Question } from "../../../../model/Question.model";
import Base from "../../../../components/base/Base.vue";
import Answers from "./answers/Answers.vue";
import { Answer } from "../../../../model/Answer.model";
import { computed, watchEffect } from "vue";
import { ChallengeSettings } from "../../../../model/ChallengeSettings.model";
import { ChallengeType } from "../../../../enum/challenge.type";
import ChallengeService from "../../../../services/challenge.service";
import { take } from "rxjs/internal/operators/take";
@Options({
  props: ["question", "index", "imageQuestion"],
  components: {
    Answers
  }
})
export default class CardQuestion extends Base {
  question!: Question;
  index!: number;
  public settingsChallenge = computed<ChallengeSettings>(
    () => this.store.getters.getChallengeSettingSelected
  ).value;
  addAnswer() {
    this.question.answers.push({ name: "" } as Answer);
  }

  checkChallengeType() {
    const name = this.settingsChallenge.name.toLowerCase();
    return {
      quiz: name === ChallengeType.quiz,
      poll: name === ChallengeType.poll,
      openEnded: name === ChallengeType.openEnded,
      random: name === ChallengeType.random
    };
  }

  created() {
    watchEffect(() => {
      ChallengeService.getQuestion
        .pipe(take(1))
        .subscribe((question: Question) => {
          question = {
            ...question
          };
          ChallengeService.setQuestion(question, question.index);
        });
    });
  }
}
</script>
